import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    getOrderSummaryData,
    setOrderSummaryModalState,
    closeOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import { sizes } from 'src/styles/Media.styled';
import OrderDetails from 'src/pages/orders/components/orderDetails/OrderDetails';
import { getFormattedPhoneNumber } from 'src/utils/util';
import {
    AccountDetailsGridContainer,
    AccountDetailsGrid,
    AccountDetailsFont,
    AccountDetailsTopTitle,
    AccountDetailsTitle,
    OrderDetailTabBodyContainer,
    OrderDetailTabBody,
    AccountDetailsPhoneFont,
} from './physicianDetails.styled';

const PhysicianDetailCard = ({ account }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    const winWidth = window.innerWidth;
    const isMobileView = winWidth <= sizes.mobileDevice;
    const openOrderDetail = (myCaseRef) => {
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: true,
            })
        );
        setShowOrderDetail(true);
    };
    const closeCardPreviewHandler = () => {
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        setShowOrderDetail(false);
    };
    const workPhoneNum = `tel:${
        account && account.workPhone && account.workPhone
    }`;
    const cellPhoneNum = `tel:${
        account && account.cellPhone && account.cellPhone
    }`;
    const alternatePhoneNum = `tel:${
        account && account.alternatePhone && account.alternatePhone
    }`;
    const emailId = `mailto:${account && account.email && account.email}`;
    return (
        <OrderDetailTabBodyContainer>
            <OrderDetailTabBody>
                <AccountDetailsGridContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <AccountDetailsGrid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={12}
                        style={{ marginTop: '-11px' }}
                    >
                       {
                        account && account.address && (
                            <>
                                <AccountDetailsTitle isDemi>
                                    {t('physicians.physicianDetailCard.address')}
                                </AccountDetailsTitle>
                                <AccountDetailsFont isRegular>
                                    <span className="more-shipping-address-dt-mask">{account.address.line1}</span><br />
                                    {account.address.line2 && (
                                        <>
                                            <span className="more-shipping-address-dt-mask">{account.address.line2}</span><br />
                                        </>
                                    )}
                                    {account.address.line3 && (
                                        <>
                                            <span className="more-shipping-address-dt-mask">{account.address.line3}</span><br />
                                        </>
                                    )}
                                    <span className="more-account-address-dt-mask">{account.address.city}</span>{', '}<span className="more-account-address-dt-mask">{account.address.state}</span>{' '}<span className="more-shipping-address-dt-mask">{account.address.postalCode}</span>
                                </AccountDetailsFont>
                            </>
                        )
                    }
                         
                       { account && account.email && (
                            <>
                                <AccountDetailsTitle isDemi>
                                    {t('physicians.physicianDetailCard.email')}
                                </AccountDetailsTitle>
                                <AccountDetailsPhoneFont
                                    className="more-physician-email-dt-mask"
                                    isRegular
                                    style={{
                                        color: '#1010EB',
                                        fontFamily: 'AvenirNextWorld Demi',
                                    }}
                                >
                                    {account && account.email && account.email}
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href={emailId}
                                    >
                                        {' '}
                                        {account &&
                                            account.email &&
                                            account.email}
                                    </a>
                                </AccountDetailsPhoneFont>
                            </>
                        )}
                        {account && account.recentSurgeryOrderDate && (
                            <>
                                <AccountDetailsTitle isDemi>
                                    {t(
                                        'physicians.physicianDetailCard.mostRecentOrder'
                                    )}
                                </AccountDetailsTitle>
                                <AccountDetailsFont isRegular>
                                    {account &&
                                        account.recentSurgeryOrderDate &&
                                        account.recentSurgeryOrderDate}{' '}
                                    &nbsp; | &nbsp;
                                    <a
                                        style={{
                                            color: '#1010EB',
                                            cursor: 'pointer',
                                            fontFamily: 'AvenirNextWorld Demi',
                                        }}
                                        onClick={() =>
                                            openOrderDetail(
                                                account.recentSurgerymyCASERef
                                            )
                                        }
                                    >
                                        {account &&
                                            account.recentSurgerymyCASERef &&
                                            account.recentSurgerymyCASERef}
                                    </a>
                                </AccountDetailsFont>
                            </>
                        )}
                        {account && account.specialty && (
                            <>
                                {' '}
                                <AccountDetailsTitle isDemi>
                                    {t(
                                        'physicians.physicianDetailCard.speciality'
                                    )}
                                </AccountDetailsTitle>
                                <AccountDetailsFont isRegular>
                                    {account &&
                                        account.specialty &&
                                        account.specialty}
                                </AccountDetailsFont>
                            </>
                        )}
                    </AccountDetailsGrid>
                    <AccountDetailsGrid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={12}
                        style={{ marginTop: '-11px' }}
                    >   
                         {/* {(salesOrg === 'S024' && countryISOCode === 'JP') ? (
                        <>
                            <AccountDetailsTopTitle isDemi>
                                {t('physicians.physicianDetailCard.workPhone')}
                            </AccountDetailsTopTitle>
                            <AccountDetailsPhoneFont isRegular>
                                {/* Add any specific content for this condition here */}
                            {/* </AccountDetailsPhoneFont> */}
                        {/* </> */}
                  
                        {account && account.workPhone && (
                            <>
                                <AccountDetailsTopTitle isDemi>
                                    {t(
                                        'physicians.physicianDetailCard.workPhone'
                                    )}
                                </AccountDetailsTopTitle>

                                <AccountDetailsPhoneFont isDemi>
                                    {isMobileView ||
                                    window.innerWidth <= sizes.mediumDevice ? (
                                        <a
                                            style={{
                                                textDecoration: 'none',
                                                fontFamily:
                                                    'AvenirNextWorld Demi',
                                            }}
                                            href={workPhoneNum}
                                        >
                                            {' '}
                                            <span className="more-contact-phone-dt-mask">{account &&
                                                account.workPhone &&
                                                getFormattedPhoneNumber(
                                                    account.workPhone
                                                )}</span>
                                        </a>
                                    ) : (
                                        <div>
                                            {' '}
                                            <span className="more-contact-phone-dt-mask">{account &&
                                                account.workPhone &&
                                                getFormattedPhoneNumber(
                                                    account.workPhone
                                                )}</span>
                                        </div>
                                    )}
                                </AccountDetailsPhoneFont>
                            </>
                        )}
                        
                        {account && account.alternatePhone && (
                            <>
                                <AccountDetailsTitle isDemi>
                                    {t(
                                        'physicians.physicianDetailCard.alternativePhone'
                                    )}
                                </AccountDetailsTitle>
                                <AccountDetailsPhoneFont
                                    className="more-physician-alternate-phone-dt-mask"
                                    isRegular
                                    // style={{ color: '#1010EB' }}
                                >
                                    {isMobileView ||
                                    window.innerWidth <= sizes.mediumDevice ? (
                                        <a
                                            style={{
                                                textDecoration: 'none',
                                                fontFamily:
                                                    'AvenirNextWorld Demi',
                                            }}
                                            href={alternatePhoneNum}
                                        >
                                            {' '}
                                            {account &&
                                                account.alternatePhone &&
                                                getFormattedPhoneNumber(
                                                    account.alternatePhone
                                                )}
                                        </a>
                                    ) : (
                                        <div>
                                            {' '}
                                            {account &&
                                                account.alternatePhone &&
                                                getFormattedPhoneNumber(
                                                    account.alternatePhone
                                                )}
                                        </div>
                                    )}
                                </AccountDetailsPhoneFont>
                            </>
                        )}
                        {account && account.fax && (
                            <>
                                <AccountDetailsTitle isDemi>
                                    {t('physicians.physicianDetailCard.fax')}
                                </AccountDetailsTitle>
                                <AccountDetailsFont className="more-physician-fax-dt-mask" isRegular>
                                    {account &&
                                        account.fax &&
                                        getFormattedPhoneNumber(account.fax)}
                                </AccountDetailsFont>
                            </>
                        )}
                    </AccountDetailsGrid>
                </AccountDetailsGridContainer>
            </OrderDetailTabBody>
            {showOrderDetail && (
                <OrderDetails
                    showOrderListDetails={showOrderDetail}
                    orderListDetailsClose={closeCardPreviewHandler}
                    fromCalendar={false}
                    fromListScreen={false}
                    isFromPhysicianDetails={true}
                />
            )}
        </OrderDetailTabBodyContainer>
    );
};
export default PhysicianDetailCard;
